/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { IdCardIcon16Light } from './IdCardIcon16Light';
import { IdCardIcon16Regular } from './IdCardIcon16Regular';
import { IdCardIcon16Solid } from './IdCardIcon16Solid';
import { IdCardIcon20Light } from './IdCardIcon20Light';
import { IdCardIcon20Regular } from './IdCardIcon20Regular';
import { IdCardIcon20Solid } from './IdCardIcon20Solid';
import { IdCardIcon24Regular } from './IdCardIcon24Regular';
import { IdCardIcon24Solid } from './IdCardIcon24Solid';
import { IdCardIcon32Regular } from './IdCardIcon32Regular';
import { IdCardIcon64Regular } from './IdCardIcon64Regular';
var sizes = {
    16: {
        light: IdCardIcon16Light,
        regular: IdCardIcon16Regular,
        solid: IdCardIcon16Solid,
    },
    20: {
        light: IdCardIcon20Light,
        regular: IdCardIcon20Regular,
        solid: IdCardIcon20Solid,
    },
    24: {
        regular: IdCardIcon24Regular,
        solid: IdCardIcon24Solid,
    },
    32: {
        regular: IdCardIcon32Regular,
    },
    64: {
        regular: IdCardIcon64Regular,
    },
};
export var IdCardIcon = forwardRef('IdCardIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
